import { colors, Tabs } from '@sweep-io/sweep-design';
import { LayoutTabsProps } from './types';
import { Stack } from '@mui/material';

export const TabsRenderer = ({ tabs, dropdown, activeTab, onTabChange }: LayoutTabsProps) => {
  return (
    <Stack sx={{ borderBottom: `1px solid ${colors.grey[120]}`, width: '100%' }}>
      <Tabs
        tabs={tabs}
        dropdown={dropdown}
        value={activeTab}
        onChange={onTabChange}
        variant="scrollable"
      />
    </Stack>
  );
};
